"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, use, type ReactNode } from "react";
import type { AppConfig } from "./config-server";
const AppConfigContext = createContext<AppConfig | null>(null);
interface AppConfigProviderProps {
  children: ReactNode;
  config: AppConfig;
}
export function AppConfigProvider(t0) {
  const $ = _c(3);
  const {
    children,
    config
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== config) {
    t1 = <AppConfigContext value={config}>{children}</AppConfigContext>;
    $[0] = children;
    $[1] = config;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function useAppConfig(): AppConfig {
  const config = use(AppConfigContext);
  if (!config) {
    throw new Error("useAppConfig must be used within an AppConfigProvider");
  }
  return config;
}